import { useState } from "react";
import { Link } from "react-router-dom";
import { forgotPassword } from "@/lib/api";
import AuthShell from "@/components/AuthShell";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2, MailCheck } from "lucide-react";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await forgotPassword(email.trim());
      setSent(true);
    } catch {
      toast.error("Anfrage fehlgeschlagen. Bitte erneut versuchen.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell
      title="Passwort vergessen"
      subtitle="Wir senden Ihnen einen Link zum Zurücksetzen."
      footer={
        <Link to="/login" className="text-primary font-medium hover:underline" data-testid="link-back-login">
          Zurück zur Anmeldung
        </Link>
      }
    >
      {sent ? (
        <div className="text-center py-4" data-testid="forgot-sent">
          <MailCheck className="h-10 w-10 text-primary mx-auto mb-3" />
          <p className="text-sm text-muted-foreground">
            Falls ein Konto mit dieser E-Mail existiert, wurde ein Link zum
            Zurücksetzen des Passworts gesendet. Bitte prüfen Sie Ihr Postfach.
          </p>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
          <div className="space-y-2">
            <Label htmlFor="email">E-Mail</Label>
            <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required autoComplete="email" data-testid="forgot-email" />
          </div>
          <Button type="submit" className="w-full" disabled={busy} data-testid="forgot-submit">
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Link senden"}
          </Button>
        </form>
      )}
    </AuthShell>
  );
}
